import Swiper, {Navigation, Pagination} from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import {clickAndEnterListener, forEachIfArray, hideSpinner, q, showSpinner,} from '../utilities';

export function initUnitedLandingPage() {
  new Swiper('.swiper-1', {
    modules: [Navigation, Pagination],
    slidesPerView: 'auto',
    centeredSlides: true,
    loop: true,
    loopedSlides: 3,
    pagination: {
      el: '.swiper-1 .swiper-pagination',
      clickable: true,
      bulletElement: 'button',
    },
    navigation: {
      nextEl: '.swiper-1 .swiper-button-next',
      prevEl: '.swiper-1 .swiper-button-prev',
    },
  });

  new Swiper('.swiper-2', {
    modules: [Navigation, Pagination],
    slidesPerView: 'auto',
    centeredSlides: true,
    pagination: {
      el: '.swiper-2 .swiper-pagination',
      clickable: true,
      bulletElement: 'button',
    },
    navigation: {
      nextEl: '.swiper-2 .swiper-button-next',
      prevEl: '.swiper-2 .swiper-button-prev',
    },
  });
}

export function initPartnerLinkFormPage() {
  const inputMemberNumber = q('input#member-number');
  const checkboxAgree = q('input[type="checkbox"]#agree');
  const checkmarkEl = q('form#link-form .checkmark');
  const formSubmitBtn = q('form#link-form #link-form-submit');
  const errorMsgEl = q('form#link-form .error-msg');
  const errorList = q('.error-msg > ul');
  const requiresAdditionalConsent = q('input[type="hidden"]#requires-additional-consent');
  const optOutTrigger = q('button#opt-out-trigger');

  let canSubmit = false;

  checkboxAgree.checked = false;
  formSubmitBtn ? formSubmitBtn.disabled = true : null;
  const hasAdditionalConsent = (requiresAdditionalConsent ? requiresAdditionalConsent.value : null);

  function checkboxChecked(checkboxEl, submitEl) {
    canSubmit = true;
    checkboxEl.checked = true;
    submitEl.disabled = false;
  }

  function checkboxUnchecked(checkboxEl, submitEl) {
    canSubmit = false;
    checkboxEl.checked = false;
    submitEl.disabled = true;
  }

  function checkmark(checkboxEl, submitEl) {
    console.log('checkmark()');
    hideError();
    if (checkboxEl.checked) {
      checkboxUnchecked(checkboxEl, submitEl);
    } else {
      checkboxChecked(checkboxEl, submitEl);
    }
  }

  clickAndEnterListener(checkmarkEl, () => {
    checkmark(checkboxAgree, formSubmitBtn);
  });

  checkboxAgree.addEventListener('input', () => {
    hideError();
    let elToEnable;

    hasAdditionalConsent
      ? elToEnable = optOutTrigger
      : elToEnable = formSubmitBtn;

    if (checkboxAgree.checked) {
      checkboxChecked(checkboxAgree, elToEnable);
    } else {
      checkboxUnchecked(checkboxAgree, elToEnable);
    }
  });

  clickAndEnterListener(q('form .checkmark'), () => {
    console.log('form checkmark');
    hideError();
    let elToEnable;

    hasAdditionalConsent
      ? elToEnable = optOutTrigger
      : elToEnable = formSubmitBtn;

    if (checkboxAgree.checked) {
      checkboxChecked(checkboxAgree, elToEnable);
    } else {
      checkboxUnchecked(checkboxAgree, elToEnable);
    }
  });

  if (hasAdditionalConsent) {
    const optOutCheckbox = q('#opt-out-modal input[type="checkbox"]#opt-out');
    const optOutCheckmark = q('#opt-out-modal .checkmark');
    const optOutSubmitBtn = q('input#opt-out-submit');

    clickAndEnterListener(optOutCheckmark, () => {
      checkmark(optOutCheckbox, optOutSubmitBtn);
    });

    optOutCheckbox.addEventListener('input', () => {
      console.log('opt out');
      hideError();
      if (optOutCheckbox.checked) {
        checkboxChecked(optOutCheckbox, optOutSubmitBtn);
      } else {
        checkboxUnchecked(optOutCheckbox, optOutSubmitBtn);
      }
    });

    clickAndEnterListener(optOutSubmitBtn, () => {
      $('#opt-out-modal').modal('hide');
      submitForm(canSubmit)
    });

  }

  function showError(errors) {
    hideError();
    for (const prop in errors) {
       const item = document.createElement('li');
        item.innerHTML = errors[prop][0];
        errorList.appendChild(item);
    }

    errorMsgEl.classList.add('show');
  }

  function hideError() {
    errorList.innerHTML = "";
    errorMsgEl.classList.remove('show');
  }

  if (inputMemberNumber) {
    inputMemberNumber.addEventListener('input', hideError);
  }

  clickAndEnterListener(formSubmitBtn, (e) => {
    submitForm(canSubmit);
  });

  function submitForm(canSubmit) {
    const formEl = q('form#link-form');

    // formEl.submit();
    // return;

    // REMOVE THIS ONCE ACTUAL FUNCTIONALITY IS IN PLACE FOR EMIRATES
    // if (
    //   q('#partner-link-form-page.emirates-page') ||
    //   q('#partner-delink-form-page.emirates-page')
    // ) {
    //   canSubmit = false;
    // }
    // -------------

    if (canSubmit) {
      let base = q('#baseUrl');
      let baseUrl = base.value;

      showSpinner(q('#link-form .loading-spinner'));
      //TODO resetFormMessages()

      const formData = new FormData(formEl);

      // [ AJAX ]
      axios.post(formEl.getAttribute('action'), formData)

        .then(function(response) {
          console.log('axios post success');
          window.location.href = response.data.redirectUri;
        })

        .catch(function(error) {
          console.log('axios post error');
          const generalErrorUri = baseUrl + 'error';
          const redirectUri = error.response.data.redirectUri || generalErrorUri;

          switch (error.response.status) {
            // not authenticated
            case 401:
              window.location.href = baseUrl + 'signed-out';
              break;

            // already linked
            case 409:
              window.location.href = redirectUri;
              break;

            // session expired or invalid csrf token
            case 419:
              window.location.reload();
              break;

            // server-side validation failed (via BenefitChoiceService or FormRequest)
            case 422:
              console.dir(error.response)

              if (error.response.data.errors) {
                showError(error.response.data.errors);
              } else {
                window.location.href = redirectUri;
              }

              break;

            // member not authorized to make a selection
            case 403:
            // fall through (maybe we should send them to 'not eligible', but the error page would make it easier for them to try again

            // general backend error
            case 500:
            // fall through

            default:
              window.location.href = redirectUri;
          }
        })

        .then(function() {
          hideSpinner(q('#link-form .loading-spinner'));
        });
    }
  }
}

export function initPartnerDelinkFormPage() {
  const checkboxEl = q('input[type="checkbox"]');
  const checkboxElLength = checkboxEl.length;
  const checkmarkEl = q('.checkmark');
  const formSubmitBtn = q('#delink-form-submit');
  const formEl = q('#delink-form');
  let canSubmit = false;
  let agreeCount = 0;

  function checkboxChecked(checkboxEl, submitEl) {
    if (agreeCount < checkboxElLength) {
      agreeCount++;
    }
    checkboxEl.checked = true;
    if (agreeCount >= checkboxElLength) {
      canSubmit = true;
      submitEl.disabled = false;
    }
  }

  function checkboxUnchecked(checkboxEl, submitEl) {
    if (agreeCount > 0) {
      agreeCount--;
    }
    canSubmit = false;
    checkboxEl.checked = false;
    submitEl.disabled = true;
  }

  function checkmark(submitEl, e) {
    const targetCheckbox = e.target.previousElementSibling.previousElementSibling;
    if (targetCheckbox.checked) {
      checkboxUnchecked(targetCheckbox, submitEl);
    } else {
      checkboxChecked(targetCheckbox, submitEl);
    }
  }

  clickAndEnterListener(checkmarkEl, (e) => {
    checkmark(formSubmitBtn, e);
  });

  forEachIfArray(checkboxEl, (el) => {
    el.addEventListener('input', (e) => {
      const targetCheckbox = e.target;
      if (targetCheckbox.checked) {
        checkboxChecked(targetCheckbox, formSubmitBtn);
      } else {
        checkboxUnchecked(targetCheckbox, formSubmitBtn);
      }
    });
  });

  function submitForm() {
     showSpinner();
     const formData = new FormData(formEl);

     axios.post(formEl.getAttribute('action'), formData)
        .then(function(response) {
          console.log('axios post success');
          window.location.href = response.data.redirectUri;
        }).catch(function(error){
          console.log(error);
          window.location.href = error.response.data.redirectUri;
       }).then(function() {
            hideSpinner();
       });
  }

  clickAndEnterListener(formSubmitBtn, submitForm);
}

function showProcessingOverlay() {
  q('#processing-overlay').classList.remove('d-none');
  showSpinner();
}

function hideProcessingOverlay() {
  q('#processing-overlay').classList.add('d-none');
  hideSpinner();
}

export function initPartnerPromoForm() {
  const formEl = q('form#promo-form')
  const formSubmitBtn = q('button[type="submit"]');

  function submitForm() {
     showSpinner();
     const formData = new FormData(formEl);

     axios.post(formEl.getAttribute('action'), formData)
        .then(function(response) {
          console.log('axios post success');
          window.location.href = response.data.redirectUri;
        }).catch(function(error){
          console.log(error);
          window.location.href = error.response.data.redirectUri;
       }).then(function() {
            hideSpinner();
       });
  }
  clickAndEnterListener(formSubmitBtn, submitForm);
}

export function initFlipCards() {
  forEachIfArray(q('.flip-container .front .flip-directions'), (el) => {
    clickAndEnterListener(el, () => {
      el.closest('.flip-container').classList.add('flip')
    });
  });
  forEachIfArray(q('.flip-container .back .flip-directions'), (el) => {
    clickAndEnterListener(el, () => {
      el.closest('.flip-container').classList.remove('flip')
    });
  });
}

export function initCathaySwipers() {
  new Swiper('.swiper', {
    modules: [Navigation, Pagination],
    slidesPerView: 'auto',
    centeredSlides: true,
    loop: true,
    loopedSlides: 3,
    pagination: {
      el: '.swiper .swiper-pagination',
      clickable: true,
      bulletElement: 'button',
    },
    navigation: {
      nextEl: '.swiper .swiper-button-next',
      prevEl: '.swiper .swiper-button-prev',
    },
  });
}

export function initBenefitsSwitcher() {
  window.axios.defaults.headers.common['X-CSRF-TOKEN'] = q('#token').dataset.token;
  const partnerLevelSelector = q('.partner-dropdown');
  const marriottLevelSelectorText = q('.marriott-dropdown > button.dropdown-toggle > span');
  const partnerLevelSelectorText = q('.partner-dropdown > button.dropdown-toggle > span');
  const marriottLevel = q('.marriott-level');
  const partnerLevel = q('.partner-level');
  const benefitsWrap = q('.benefits-wrap');
  const benefitsContainer = q('#benefits');
  const notEligible = q('#not-eligible');
  const plus = document.createElement('div');
  const mobilePlus = document.createElement('div');
  const plusSpan = document.createElement('span');
  const spinner = document.createElement('div');

  spinner.classList.add('loading-spinner');
  plusSpan.innerText = '+';
  plus.classList.add('plus', 'position-absolute', 'd-none');
  mobilePlus.classList.add('plus', 'position-absolute', 'd-sm-none');
  plus.append(plusSpan)
  mobilePlus.append(plusSpan.cloneNode(true));
  benefitsWrap.append(plus, spinner);

  const selected = {
    'marriottMemberLevel': 0,
    'partnerMemberLevel': 0,
  }

  function enablePartnerSelector() {
    if (partnerLevelSelector.classList.contains('disabled')) {
      partnerLevelSelector.classList.remove('disabled');
    }
  }

  function filterPartnerSelections(showsPartnerLevels) {
    const valid = showsPartnerLevels.split(" ");
    partnerLevel.map(l => l.classList.add('hide'))
    selected.partnerMemberLevel = 0;
    partnerLevelSelectorText.classList.add('placeholder');
    const eligibleKrisflyerText = APP_singapore_content.landing.sec_2.krisflyer_list[0].item;
    partnerLevelSelectorText.innerText = eligibleKrisflyerText;
    benefitsContainer.innerHTML = '';
    notEligible.classList.remove('hide');
    if (valid) {
      valid.map(i => q('button#' + i).classList.remove('hide'));
    }
  }

  function setMarriottLevel(event) {
    selected.marriottMemberLevel = event.target.dataset.level;
    marriottLevelSelectorText.innerText = event.target.innerText;
    filterPartnerSelections(event.target.dataset.showsPartnerLevels);
    enablePartnerSelector();
    benefitsContainer.innerHTML = '';
    if(selected.partnerMemberLevel !== 0) {
      fetchBenefits();
    }
    marriottLevelSelectorText.classList.remove('placeholder');
  }
  function setPartnerLevel(event) {
    selected.partnerMemberLevel = event.target.dataset.level;
    partnerLevelSelectorText.innerText = event.target.innerText;
    benefitsContainer.innerHTML = '';
    fetchBenefits();
    partnerLevelSelectorText.classList.remove('placeholder');
  }

  function renderBenefits(data) {
    notEligible.classList.add('hide');
    let eligible = data['eligibleFor'];
    let count = 0;
    const moreThanOne =  eligible ? Object.keys(eligible).length > 2 : false;

    for (let i in eligible) {
      if (typeof eligible[i] == 'object') {
        count ++;
        const benefitCopy = eligible[i]
        const {card, flipper, front, back, headline, body, list} = buildBenefitTemplate();

        headline.innerHTML = benefitCopy['headline'];

        if (benefitCopy['styling_classes'].search('border') > 0) {
          const icon = document.createElement('img');
          icon.src = '/images/icon_accelerate.png';
          icon.classList.add('icon-accelerate');
          card.prepend(icon);
          card.classList.add(...benefitCopy['styling_classes'].split(" "));
        }

        body.innerHTML = benefitCopy['body'];

        benefitCopy['benefits'].forEach(benefit => {
          const item = document.createElement('li');
          item.classList.add('pb-0');
          item.innerHTML = benefit;
          list.append(item);
        });

        front.append(headline, body);
        back.append(list);

        flipper.append(front, back);
        card.append(flipper);

        if (moreThanOne && count === 1) {
          card.append(mobilePlus);
        }

        benefitsContainer.append(card);
      }
    }

    benefitsContainer.classList.add('benefit-cards-amount-' + count);
    if (moreThanOne) {
      plus.classList.add('d-sm-flex');
    } else {
      if (count === 0) {
        notEligible.classList.remove('hide');
      }
      benefitsContainer.classList.remove('benefit-cards-amount-2')
      plus.classList.remove('d-sm-flex');
    }
    hideSpinner()
  }

  function fetchBenefits() {
    showSpinner();
    window.axios.post('/singapore/en-gb/benefits-switcher', {
      marriottMemberLevel: selected.marriottMemberLevel,
      partnerMemberLevel: selected.partnerMemberLevel,
    }).then(function (response) {
      renderBenefits(response.data);
    }).catch(function (error) {
      console.error(error);
    });
  }

  function buildBenefitTemplate() {
    const card = document.createElement('div');
    card.classList.add('d-flex', 'position-relative');
    const flipper = document.createElement('div');
    flipper.classList.add('flipper', 'benefit-card', 'w-100');
    const front = document.createElement('div');
    front.classList.add('front');
    const back = document.createElement('div');
    back.classList.add(('back'));
    const headline = document.createElement('h3');
    headline.classList.add('subheading', 'fz-sm');
    const body = document.createElement('p');
    body.classList.add('fz-2xs');
    const list = document.createElement('ul');
    list.classList.add('list-style-none', 'text-center', 'fz-2xs', 'ml-0');
    return {card, flipper, front, back, headline, body, list};
  }

  clickAndEnterListener(marriottLevel, setMarriottLevel);
  clickAndEnterListener(partnerLevel, setPartnerLevel);
}

export function initMilesAndMoreBenefits() {
  new Swiper('.swiper', {
    modules: [Pagination],
    loop: true,
    slidesPerView: 1,
    spaceBetween: 20,
    pagination: {
      el: '.swiper .swiper-pagination',
      clickable: true,
      bulletElement: 'button',
    },
  });
}
